import React from "react";
import { Instagram, Youtube, Facebook } from "lucide-react";

const PatreonIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M14.82 2.41c3.96 0 7.18 3.24 7.18 7.21 0 3.96-3.22 7.18-7.18 7.18-3.97 0-7.21-3.22-7.21-7.18 0-3.97 3.24-7.21 7.21-7.21M2 21.6h3.5V2.41H2V21.6z" />
  </svg>
);

export const SOCIAL_LINKS = [
  { label: "Instagram", icon: Instagram, href: "https://www.instagram.com/ottojuniormusic/" },
  { label: "Youtube", icon: Youtube, href: "https://www.youtube.com/@ottojunior468" },
  { label: "Facebook", icon: Facebook, href: "https://www.facebook.com/share/1EEkXVeFYX/?mibextid=wwXIfr" },
  { label: "Patreon", icon: PatreonIcon, href: "https://www.patreon.com/c/OttoJuniorMusic" },
];
